import BaseComponent from "../baseComponent.js";
import styles from "./data-bank.scss";

export default class SearchBox extends BaseComponent {
  constructor(props) {
    super(props)
  }

  onSearchStringChange(event) {
    let searchString = event.currentTarget.value.trim();
    clearTimeout(this.searchChangeTimeout);
    this.searchChangeTimeout = setTimeout(() => {
      this.props.onSearchStringChange(searchString);
    }, 500);
  }

  render() {
    return (
      <div className="row">
        <div className={["col s12", styles.searchBox].join(" ")}>
          <input placeholder="search"
                 onChange={(e) => this.onSearchStringChange(e)}/>
        </div>
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/components/data-bank/searchBox.jsx